export const EXPORT_JOB_STATUS_LABEL: Record<string, string> = {
  pending: "Chờ xử lý",
  processing: "Đang xử lý",
  done: "Hoàn thành",
  failed: "Thất bại",
};

export const EXPORT_JOB_STATUS_COLOR: Record<string, string> = {
  pending: "yellow",
  processing: "blue",
  done: "green",
  failed: "red",
};

export enum ExportModule {
  SALE_ORDER = "sale_order",
  PURCHASE_ORDER = "purchase_order",
  DEBT = "debt",
}

export const EXPORT_MODULE_LABEL: Record<string, string> = {
  [ExportModule.SALE_ORDER]: "Đơn bán hàng",
  [ExportModule.PURCHASE_ORDER]: "Đơn mua hàng",
  [ExportModule.DEBT]: "Công nợ",
};
